import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import UnlockWithCoreUpsellModal from '../UnlockWithCoreUpsellModal/UnlockWithCoreUpsellModal';

import s from './AttachmentUpsellModal.scss';

export interface Props {
  requestClose: () => void;
}

const AttachmentUpsellModal: React.FC<Props> = ({ requestClose }) => {
  const { t } = useTranslation();
  
  const body = (
    <div className={s['body']}>
      {t('coreUpsellModal.maxAttachments.text')}
    </div>
  );

  return (
    <UnlockWithCoreUpsellModal
      title={t('coreUpsellModal.maxAttachments.title')} 
      body={body}
      cta={t('coreUpsellModal.maxAttachments.ctaLabel')}
      referralType={ReferralType.SUBMIT_MULTI_IMAGE_LIMIT}
      referer={Url.studio()}
      className={s['root']}
      requestClose={requestClose}
    />
  );
};
AttachmentUpsellModal.displayName = 'AttachmentUpsellModal';

export default AttachmentUpsellModal;
